




import {Component, Prop, Vue} from "vue-property-decorator";
import {ReceiptExpensesPickingListTargetType} from "@/enums/type";

@Component({
  name: "ReceiptExpensesPickingListTargetTypeLabel"
})
export default class extends Vue {
  @Prop({ type: Number, required: true }) readonly targetType!: number;

  ReceiptExpensesPickingListTargetType = ReceiptExpensesPickingListTargetType;
}
